import { Box } from "@material-ui/core";
import TravaLogo from "src/components/Icon/TravaLogo";
import ConnectedButton from "../ConnectedButton";
import HeaderTab from "../HeaderTab";
import ToggleNetworkButton from "../ToggleNetworkButton";
import ToggleThemeButton from "../ToggleThemeButton";

export default function DesktopHeader() {
  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" height="100%">
      <Box display="flex" justifyContent="flex-start" alignItems="center">
        <TravaLogo />
        <HeaderTab />
      </Box>
      <Box display="flex" justifyContent="flex-end" alignItems="center">
        <Box mr={2}>
          <ToggleNetworkButton />
        </Box>
        <Box mr={1}>
          <ConnectedButton />
        </Box>
        <ToggleThemeButton />
      </Box>
    </Box>
  );
}
